import { render, staticRenderFns } from "./editCompany-certify.vue?vue&type=template&id=5c8316b0&"
import script from "./editCompany-certify.vue?vue&type=script&lang=js&"
export * from "./editCompany-certify.vue?vue&type=script&lang=js&"
import style0 from "./editCompany-certify.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports